export enum AccountUserRoleEnum {
  invalid = 'invalid',
  full_access = 'full_access',
  limited_access = 'limited_access',
}
